import { VariantProps, cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

const inputVariants = cva(
  [
    'preflight',
    'ds-h-4',
    'ds-w-4',
    'focus:ds-ring-acuity-blue',
    'ds-border-neutrals',
    'ds-border',
    'ds-border-solid'
  ],
  {
    variants: {
      disabled: {
        false: [
          'ds-text-acuity-blue',
          'ds-bg-neutrals-white',
          'hover:ds-border-acuity-blue',
          'hover:ds-bg-acuity-blue-lightest',
          'hover:ds-text-acuity-blue-dark',
          'active:ds-border-acuity-blue-darkest',
          'active:ds-bg-acuity-blue-darkest',
          'active:ds-text-acuity-blue-darkest',
          'ds-cursor-pointer'
        ],
        true: ['ds-text-neutrals', 'ds-bg-neutrals-lighter']
      }
    }
  }
);
interface InputVariants extends VariantProps<typeof inputVariants> {}
export const inputStyles = (variants: InputVariants) => twMerge(inputVariants(variants));

const labelVariants = cva(
  ['preflight', 'ds-font-base', '!ds-font-sans', 'ds-ml-2', 'ds-text-base'],
  {
    variants: {
      disabled: {
        false: 'ds-cursor-pointer',
        true: 'ds-text-neutrals'
      }
    }
  }
);
interface LabelVariants extends VariantProps<typeof labelVariants> {}
export const labelStyles = (variants: LabelVariants) => twMerge(labelVariants(variants));

export const commonVariants = {
  variants: {
    state: {
      default: [
        'ds-border-neutrals',
        'ds-text-neutrals-darker',
        'focus:ds-border-acuity-blue',
        'focus:ds-ring-acuity-blue',
        'focus:ds-ring-offset-2',
        'focus:ds-ring-2'
      ],
      error: [
        'ds-border-danger-red',
        'ds-text-danger-red-darkest',
        'focus:ds-border-danger-red',
        'focus:ds-ring-danger-red-dark',
        'focus:ds-ring-offset-2',
        'focus:ds-ring-2'
      ],
      success: [
        'ds-border-success-green',
        'ds-text-neutrals-darker',
        'focus:ds-border-success-green',
        'focus:ds-ring-success-green-dark',
        'focus:ds-ring-offset-2',
        'focus:ds-ring-2'
      ]
    },
    disabled: {
      true: [
        '!ds-border-neutrals',
        '!ds-text-neutrals-darker',
        '!ds-bg-neutrals-lighter',
        'focus:!ds-border-neutrals',
        'focus:!ds-ring-neutrals-dark',
        'ds-cursor-not-allowed'
      ]
    }
  }
};
